import { inject, Injectable } from '@angular/core';
import { AutomatedActionRecipientActionType } from './automated-action-recipient-select-enum';
import { AppTextService } from '../app-text';

@Injectable()
export class FiAutomatedActionRecipientHelperService {
    private readonly appTextService = inject(AppTextService);

    private getActionText(
        actionType: AutomatedActionRecipientActionType,
        taskTextId: string,
        notificationTextId: string,
    ): string {
        return this.appTextService.get(
            actionType === AutomatedActionRecipientActionType.CreateTask ? taskTextId : notificationTextId,
        );
    }

    getTargetLabelText(actionType: AutomatedActionRecipientActionType): string {
        return this.getActionText(
            actionType,
            'checklist.checkpoint_action_target_label_task',
            'checklist.checkpoint_action_target_label_notification',
        );
    }

    getTargetHintText(actionType: AutomatedActionRecipientActionType): string {
        return this.getActionText(
            actionType,
            'checklist.checkpoint_action_target_hint_task',
            'checklist.checkpoint_action_target_hint_notification',
        );
    }

    getRolesLabelText(actionType: AutomatedActionRecipientActionType): string {
        return this.getActionText(
            actionType,
            'checklist.checkpoint_action_recipient_roles_label_task',
            'checklist.checkpoint_action_recipient_roles_label_notification',
        );
    }

    getRolesSelectHintText(actionType: AutomatedActionRecipientActionType, isLocalRoles: boolean): string {
        const taskTextId = isLocalRoles
            ? 'checklist.checkpoint_action_recipient_local_roles_hint_task'
            : 'checklist.checkpoint_action_recipient_roles_hint_task';
        const notificationTextId = isLocalRoles
            ? 'checklist.checkpoint_action_recipient_local_roles_hint_notification'
            : 'checklist.checkpoint_action_recipient_roles_hint_notification';
        return this.getActionText(actionType, taskTextId, notificationTextId);
    }

    getUnitsHintText(actionType: AutomatedActionRecipientActionType): string {
        return this.getActionText(
            actionType,
            'checklist.checkpoint_action_recipient_units_hint_task',
            'checklist.checkpoint_action_recipient_units_hint_notification',
        );
    }

    getUsersLabelText(actionType: AutomatedActionRecipientActionType): string {
        return this.getActionText(
            actionType,
            'checklist.checkpoint_action_recipient_users_label_task',
            'checklist.checkpoint_action_recipient_users_label_notification',
        );
    }

    getUsersSelectHintText(actionType: AutomatedActionRecipientActionType): string {
        return this.getActionText(
            actionType,
            'checklist.checkpoint_action_recipient_users_hint_task',
            'checklist.checkpoint_action_recipient_users_label_notification',
        );
    }
}
